import { render, staticRenderFns } from "./TermosCondicoes.vue?vue&type=template&id=d95404ce&scoped=true"
import script from "./TermosCondicoes.vue?vue&type=script&lang=js"
export * from "./TermosCondicoes.vue?vue&type=script&lang=js"
import style0 from "./TermosCondicoes.vue?vue&type=style&index=0&id=d95404ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95404ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TermosReembolso: require('/home/luiz/Sistemas/loja/components/Termos/Reembolso.vue').default,TermosGarantia: require('/home/luiz/Sistemas/loja/components/Termos/Garantia.vue').default})
